import { z } from 'zod'

export const FinancialCacheSchema = z.object({
  computedAt: z.iso.datetime({ offset: true }),
  hit: z.boolean(),
})
